export default "__VITE_ASSET__BH3V$uIA__"